import React from 'react';
import PropTypes from 'prop-types';
import Yup from 'yup';
import { join } from 'lodash';
import { Field } from 'formik';
import {
  FormSectionHeading,
  getNameValidation,
  getPhoneNumberFormValidation,
  GridContainer,
  GridItem,
  NameForm,
  PhoneNumberForm,
  TextFieldWrapper,
} from '../../common';
import BirthdayField from '../../ChildInformationPage/components/BirthdayField';

const PROVIDER = 'provider';
const GROUP_NUMBER = 'groupNumber';
const PROVIDER_NAME = 'name';
const POLICY_NUMBER = 'policyNumber';
const POLICY_HOLDER = 'policyHolder';
const CASE_MANAGER = 'caseManager';
const NOTES = 'notes';

function Insurance({ paths, setFieldValue, values }) {
  return (
    <GridContainer>
      <FormSectionHeading>Insurance Provider</FormSectionHeading>
      <GridItem lg={4} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={PROVIDER}
          label="Company Name"
          name={join([...paths, PROVIDER, PROVIDER_NAME], '.')}
          paths={[...paths, PROVIDER, PROVIDER_NAME]}
        />
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={GROUP_NUMBER}
          label="Group Number"
          name={join([...paths, PROVIDER, GROUP_NUMBER], '.')}
          paths={[...paths, PROVIDER, GROUP_NUMBER]}
        />
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={POLICY_NUMBER}
          label="Policy Number"
          name={join([...paths, PROVIDER, POLICY_NUMBER], '.')}
          paths={[...paths, PROVIDER, POLICY_NUMBER]}
        />
      </GridItem>
      <GridItem lg={5} xs={12}>
        <PhoneNumberForm
          hasExtension
          label="Phone"
          paths={[...paths, PROVIDER]}
          required={false}
          setFieldValue={setFieldValue}
          values={values}
        />
      </GridItem>
      <FormSectionHeading>Policy Holder</FormSectionHeading>
      <NameForm paths={[...paths, POLICY_HOLDER]} required={false} />
      <BirthdayField
        paths={[...paths, POLICY_HOLDER]}
        required={false}
        setFieldValue={setFieldValue}
        values={values}
      />
      <FormSectionHeading>Case Manager</FormSectionHeading>
      <NameForm paths={[...paths, CASE_MANAGER]} required={false} />
      <GridItem lg={6} xs={12}>
        <PhoneNumberForm
          hasExtension
          paths={[...paths, CASE_MANAGER]}
          required={false}
          setFieldValue={setFieldValue}
          values={values}
        />
      </GridItem>
      <GridItem lg={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NOTES}
          label="Notes"
          multiline
          name={join([...paths, PROVIDER, NOTES], '.')}
          paths={[...paths, PROVIDER, NOTES]}
        />
      </GridItem>
    </GridContainer>
  );
}

Insurance.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  paths: PropTypes.array,
};

Insurance.defaultProps = {
  paths: [],
};

export default Insurance;

export const getInsuranceValidation = () => ({
  [PROVIDER]: Yup.object().shape({
    [PROVIDER_NAME]: Yup.string(),
    [GROUP_NUMBER]: Yup.string(),
    [POLICY_NUMBER]: Yup.string(),
    ...getPhoneNumberFormValidation(),
  }),
  [POLICY_HOLDER]: Yup.object().shape(getNameValidation()),
  [CASE_MANAGER]: Yup.object().shape({
    ...getNameValidation(),
    ...getPhoneNumberFormValidation(),
  }),
});



// WEBPACK FOOTER //
// ./src/modules/InsurancePage/components/Insurance.js